<div class="head">
  <h2>{{ '+SEARCH.SEARCH_FIELDS.TITLE' | translate }}</h2>
  <vi-tabs
    [tabs]="tabs"
    [changeSelectedTab]="activeSearch$"
    (select)="onSearchOptionChange($event)"
  ></vi-tabs>
  <div class="input-wrapper">
    <ng-container [ngSwitch]="activeSearch$ | async">
      <app-gateway-search data-at-gateway-search *ngSwitchCase="'gateway'"></app-gateway-search>
      <app-user-search data-at-user-search *ngSwitchCase="'user'"></app-user-search>
      <app-error-search data-at-error-search *ngSwitchCase="'error'"></app-error-search>
      <app-vouchers data-at-vouchers-search *ngSwitchCase="'activationCodes'"></app-vouchers>
    </ng-container>
  </div>
</div>
